import { Component, effect, inject } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";
import { CardModalService } from "@shared/card-modal";
import { WkIconMemberSpritePds3, WkIconActiveMemberSpritePds3 } from "@app/card-modal-component/panels/west-panels/t1-west-panel/icons";

@Component({
    selector: "wk-t1-west-panel",
    imports: [JumpstartComponentsModule, TranslateModule, WkIconMemberSpritePds3, WkIconActiveMemberSpritePds3],
    templateUrl: "./t1-west-panel.component.html",
    styleUrl: "./t1-west-panel.component.scss",
    host: { class: ".wk-cm__west-panel__t1 fancy-scrollbar-newUI" },
})
export class T1WestPanelComponent {
    public readonly cardModalService = inject(CardModalService);
    isMembersReturnStatusSame = false;

    constructor() {
        effect(() => {
            this.hasSameProperty(this.cardModalService.members(), "statusId")
                .then((allSameCategory) => {
                    this.isMembersReturnStatusSame = allSameCategory;
                })
                .catch((error) => {
                    console.error("An error occurred:", error);
                });
        });
    }

    async hasSameProperty<T>(arr: T[], property: keyof T): Promise<boolean> {
        if (arr.length === 0) return true;

        const firstValue = arr[0][property];
        const results = await Promise.all(
            arr.map(async (item) => {
                return item[property] === firstValue;
            }),
        );

        return results.every(Boolean);
    }

    handleMemberNameClick(cardId: string) {
        this.cardModalService.clickedMembers.set(cardId);
    }

    sanatizeId(id: string): string {
        return id.replaceAll(/[{}]/g, "");
    }
}
